import React, { useEffect, useState } from 'react'
import './FormSimulator.css'
import apollo_client from '../../../../apollo_client';
import firebase from "../../../../Firebase/firebase";
import { formsQuery, Register } from './Queries/FormQueries'
import Popup1 from '../../Crew/popup1';
function FormSimulator() {
    const [users, setusers] = useState(null)
    const [search, setsearch] = useState('')
    const [dashboardDetails, setdashboardDetails] = useState([])
    const [popupToggle1, setpopupToggle1] = useState(false);
    const [Blankform, setBlankform] = useState("");
    const popup1 = (data) => {
        setpopupToggle1(!popupToggle1);
        setBlankform(data);
    };
    useEffect(() => {
        firebase.auth().onAuthStateChanged(async (user) => {
            if (user) {
                setusers(user.uid);
                let responsedetails = await apollo_client.query({
                    query: Register,
                    variables: { id: users }
                });
                let dashboardDet = await apollo_client.query({
                    query: formsQuery,
                    variables: {
                        clientsid: responsedetails.data?.aatmsv4_register[0].clientsid,
                        id:user.uid
                    }
                });
                console.log(dashboardDet.data.aatmsv4_smap)
                if(dashboardDet.data){
                    setdashboardDetails(dashboardDet.data.aatmsv4_smap)
                }
               
            }
        });
    }, [])
    return (
        <div className="simulator-dashboard">
             <div className=" medium-margin-top category-title"> Forms</div>
             
            {popupToggle1 === true ? (
                <Popup1
                    setpopupToggle1={setpopupToggle1}
                    simulatorData={Blankform}
                />
            ) : null}
            <div className="table-body-container">
            <div className="search-bar">
                <label className="pdr10">Search</label>
                <input
                    type="text"
                    value={search}
                    className="simulator-search"
                    onChange={(e) => setsearch(e.target.value)}
                />
            </div>


            {
                dashboardDetails && dashboardDetails.length > 0 ?
                    (
                        <div>
                            
                            {
                                dashboardDetails.map((data, index) => {
                                    if (data.simformname.includes(search)) {
                                        return (

                                            <div key={index} className="row-top-2">
                                                <div className="items">
                                                    <div className=" title">Simulator Form Name</div>
                                                    <div className="">{data.simformname}</div>
                                                </div>
                                                <div className="items">
                                                    <div className=" title">Blank Form</div>
                                                    <div className=""><a onClick={() => { popup1(data.simform.blankform); }}>Link</a></div>
                                                </div>
                                                <div className="items">
                                                    <div className=" title">Study Material</div>
                                                    <div className=""><a onClick={() => { popup1(data.simform.studymat); }}>Link</a></div>
                                                </div>
                                                <div className="items">
                                                    <div className=" title">Presentation</div>
                                                    <div className=""><a onClick={() => { popup1(data.simform.presentation); }}>Link</a></div>
                                                </div>

                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                    ) :
                    (
                        <div className="row">
                            <div className="col-lg-12 title">No Forms Available</div>
                        </div >
                    )
            }
            </div>
        </div >
    )
}

export default FormSimulator
